import type {ChangeEvent as SelectChangeEvent} from '../select/types';
import type {TagItem} from './tag-item';

export enum TagInputTheme {
  Default = `default`,
  // This is a slight bastardization of the "tag-input". We need a lot of
  // similar functionality but it has nothing to do with "tags" conceptually,
  // but rather a path down a tree.
  Breadcrumbs = `breadcrumbs`,
}

export type TagInputChangeEvent = CustomEvent<{tag: TagItem; action: `removeTag`} | {value: string; action: `text`}>;

export type TagInputJsxProps = {
  attrs: {
    error?: boolean;
    'min-tags'?: number;
    'search-text'?: string;
    'show-search-icon'?: boolean;
    tags?: TagItem[];
    placeholder?: string;
    'disable-input'?: boolean;
    'mp-select-attrs'?: Obj;
    theme?: TagInputTheme;
  };
  on: {
    optionSelected?: (ev: SelectChangeEvent<TagItem>) => void;
    change?: (ev: TagInputChangeEvent) => void;
  };
};

export type TagInputState = {
  isInputFocused: boolean;
  inputText: string;
  inputWidth: string;
  tags: Set<TagItem>;
};
